import React from 'react';

const teachingExperience = [
  {
    course: "Introduction to Law and Legal Skills",
    code: "LAWS10160",
    institution: "University of Manchester",
    year: "2023-Present",
    description: "Delivering lectures and seminars on foundational legal principles, legal research methodologies, and practical legal skills to undergraduate students."
  },
  {
    course: "Human Rights in International Relations",
    code: "IR-350",
    institution: "National Defence University Islamabad",
    year: "2021",
    description: "Taught an undergraduate course focusing on the evolution of human rights in international law, key human rights instruments, and contemporary challenges."
  },
];

const leadershipProgrammes = [
  {
    title: "Emerging Leaders programme on Freedom of religion or belief",
    institution: "Cumberland Lodge, The Great Park, Windsor, United Kingdom",
    year: "2019",
    description: "Participated in a programme fostering leadership skills and promoting understanding of religious freedom and belief in diverse societies."
  },
  {
    title: "Chevening Scholar",
    institution: "UK",
    year: "2018/19",
    description: "Awarded the prestigious Chevening Scholarship for postgraduate study in the UK, recognising leadership potential and academic excellence."
  },
  {
    title: "Emerging Leaders of Pakistan Fellowship",
    institution: "South Asia Centre, Atlantic Council, Washington DC",
    year: "2014",
    description: "Selected for a fellowship designed to cultivate future leaders from Pakistan, providing exposure to U.S. policy-making and international relations."
  },
  {
    title: "Pakistan Youth Foreign Minister",
    institution: "Youth Parliament Pakistan, Islamabad",
    year: "2013-2015",
    description: "Served as a youth representative, engaging in parliamentary debates and advocating for youth perspectives on national and international issues."
  },
];

const Teaching: React.FC = () => {
  return (
    <section id="teaching" className="bg-white section-padding">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Teaching & Leadership
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Teaching Section */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Teaching</h3>
            <ul className="space-y-4">
              {teachingExperience.map((course, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-prestige-600 mr-3 mt-1 text-base">•</span>
                  <div className="flex-1">
                    <div className="font-medium text-gray-800 text-base mb-1">{course.course}</div>
                    <div className="text-gray-600 text-sm mb-1">{course.code} • {course.institution} • {course.year}</div>
                    <div className="text-gray-600 text-xs">{course.description}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Leadership Section */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Leadership</h3>
            <ul className="space-y-4">
              {leadershipProgrammes.map((programme, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-prestige-600 mr-3 mt-1 text-base">•</span>
                  <div className="flex-1">
                    <div className="font-medium text-gray-800 text-base mb-1">{programme.title}</div>
                    <div className="text-gray-600 text-sm mb-1">{programme.institution} • {programme.year}</div>
                    <div className="text-gray-600 text-xs">{programme.description}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teaching;
